import { createFileRoute } from "@tanstack/react-router";
import LiveGalleryPage from "@/components/gallery/LiveGalleryPage";

export const Route = createFileRoute("/live/$slug")({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  return <LiveGalleryPage slug={slug} />;
}
